const AMOStatus = (response) => {
    if (response)
        return {
            status: response.sts == "true" ? true : false,
        };
    return {};
};
export default AMOStatus;
